module.exports = __webpack_public_path__ + "img/step_three_brands.a10adbe6.jpg";